import { useState, type ReactNode } from "react";
import { useI18n } from "@expertloop/i18n/react";

interface CollapsibleCardProps {
	id?: string;
	title: ReactNode;
	/** Contenu à droite de l'en-tête (sélecteurs, filtres) ; reste visible repliée. */
	headerExtra?: ReactNode;
	/** Sous le titre, dans l'en-tête. */
	subtitle?: ReactNode;
	className?: string;
	defaultOpen?: boolean;
	children: ReactNode;
}

/**
 * Bloc d'information de la colonne de dossier, repliable d'un clic sur son titre. Le contenu
 * replié n'est pas rendu : une longue chronologie ne pèse plus sur la page.
 */
export function CollapsibleCard({ id, title, headerExtra, subtitle, className = "", defaultOpen = true, children }: CollapsibleCardProps) {
	const { t } = useI18n();
	const [open, setOpen] = useState(defaultOpen);
	const bodyId = id ? `${id}-body` : undefined;

	return (
		<section className={`card collapsible-card ${className}`.trim()} id={id}>
			<div className="card-header">
				<div>
					<button
						type="button"
						className="collapsible-toggle"
						aria-expanded={open}
						aria-controls={bodyId}
						title={open ? t("adminChatDetail.collapse.hide") : t("adminChatDetail.collapse.show")}
						onClick={() => setOpen((value) => !value)}
					>
						<i className={`fas ${open ? "fa-chevron-down" : "fa-chevron-right"}`} aria-hidden="true"></i>
						<h2>{title}</h2>
					</button>
					{subtitle}
				</div>
				{headerExtra}
			</div>
			{open && (
				<div className="card-body" id={bodyId}>
					{children}
				</div>
			)}
		</section>
	);
}
